import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import numeral from 'numeral'

class JobsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'purchase_order_id',
        render: (id, record) => (
          <Link
            to={`/jobView/${record.job_id}/${record.job_type}/vendors/purchase-order/modal/${id}`}
          >
            {id}
          </Link>
        )
      },
      {
        title: 'Job ID',
        dataIndex: 'job_id'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name'
      },
      {
        title: 'Name',
        dataIndex: 'description'
      },
      {
        title: 'Vendor',
        dataIndex: 'organization_name'
      },
      {
        title: 'Grand Total',
        dataIndex: 'purchase_order_grand_total_formatted'
      },
      {
        title: 'Created Date',
        dataIndex: 'purchase_order_created_date'
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item.purchase_order_created_date = moment(new Date(item.purchase_order_created_date)).format(
        'YYYY-MM-DD'
      )
      item.purchase_order_grand_total_formatted = numeral(item.purchase_order_grand_total).format(
        '$0,0.00'
      )
      return item
    })

    return data
  }

  getGrandTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.purchase_order_grand_total
    })
    return sum
  }

  tableComponents = (key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td />
          <td />
          <td className="padding8">{numeral(this.getGrandTotal()).format('$0,0.00')}</td>
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              components={{ table: this.tableComponents() }}
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default JobsAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/purchase-orders/ListItems.js